import { bondFormFileUrlQueryKey } from "@portal/api/bond";
import type { FC } from "react";
import { AdminBondFormCard } from "../../../shared/AdminBondFormCard";
import type { BondPageBodyProps } from "../types";

export const AdminBondFormTab: FC<BondPageBodyProps> = ({ bond }) => (
	<div data-testid="admin-bond-form-tab">
		<AdminBondFormCard
			bondForm={bond.bondForm}
			status={bond.status}
			bondFormViewUrl={`/v2/admin/surety/bonds/${bond.id}/bond-form`}
			bondFormViewQueryKey={bondFormFileUrlQueryKey(bond.id, false)}
		/>
	</div>
);
